// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMINCLUB_MENU = "Adminclub";
export const DELETE = "Vyma\u017e";
export const GROUP_EDIT = "Uprav popis a fotku";
export const GROUP_REPORTED_POSTS = "Nahl\u00e1\u0161en\u00e9 p\u0159\u00edsp\u011bvky";
